export default "__VITE_ASSET__nKHB1cAc__"